import { useMemo } from 'react';

import { Society } from 'types';
import operationTypeCountMap from 'constants/operationTypeCountMap';

type UseGetOperationsCountProps = {
  society: Society;
  filters: string[];
};

export const useGetOperationsCount = ({
  society,
  filters,
}: UseGetOperationsCountProps) => {
  const operationsCount: number = useMemo(() => {
    if (filters.length === 0) {
      return society?.operationsCount?.total ?? 0;
    }

    let count = 0;
    filters.forEach((filter) => {
      const operationCount =
        society?.operationsCount?.[
          operationTypeCountMap[
            filter as keyof typeof operationTypeCountMap
          ] as keyof typeof society.operationsCount
        ] ?? 0;
      count += operationCount;
    });
    return count;
  }, [society, filters]);

  return {
    data: {
      operationsCount,
    },
  };
};
